import React from 'react';
import { CTAButton } from './CTAButton';
export function SolutionSection() {
  return <section className="bg-[#102A1F] py-4 md:py-6 px-3 relative border-b border-[#1F3D2B]" data-id="element-193">
      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-194">
        <div className="inline-block bg-[#0B1F17] border border-[#D4A843] text-[#D4A843] font-black px-3 py-1 rounded-full mb-2 uppercase tracking-widest text-[10px] md:text-xs shadow-lg" data-id="element-195">
          💡 SOLUCIÓN
        </div>

        <h2 className="text-xl md:text-3xl font-black text-white mb-2 uppercase tracking-tight" data-id="element-196">
          🔥 KIT COMPLETO{' '}
          <span className="text-[#D4A843]" data-id="element-197">PRODUCCIÓN FORESTAL LISTO</span>
        </h2>

        <p className="text-sm md:text-base text-[#BFC9C5] font-bold mb-3 max-w-xl mx-auto leading-snug" data-id="element-198">
          Un sistema completo para dejar de pensar tus clases y empezar a
          ejecutarlas con seguridad.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2 max-w-2xl mx-auto mb-3 text-left" data-id="element-199">
          {[{
          text: '6 tomos completos (480 págs)',
          icon: '📚'
        }, {
          text: 'Contenido técnico explicado',
          icon: '✅'
        }, {
          text: 'Actividades y prácticas',
          icon: '📋'
        }, {
          text: 'Evaluaciones listas',
          icon: '📈'
        }, {
          text: 'Sistema estructurado',
          icon: '⚙️'
        }].map((item, i) => <div key={i} className="flex items-center gap-2 bg-[#0B1F17] border border-[#1F3D2B] p-2 rounded-lg" data-id="element-200">
              <span className="text-sm flex-shrink-0" data-id="element-201">{item.icon}</span>
              <span className="text-[#74C69D] font-bold text-xs md:text-sm leading-tight" data-id="element-202">
                {item.text}
              </span>
            </div>)}
        </div>

        <div className="w-full h-px bg-gradient-to-r from-transparent via-[#D4A843]/50 to-transparent my-3" data-id="element-203"></div>

        <div className="flex flex-wrap justify-center gap-2 mb-3 max-w-2xl mx-auto" data-id="element-204">
          {['🌱 Sistemas forestales', '🌿 Viveros forestales', '🌲 Plantación y manejo', '🌳 Especies forestales', '🪵 Aprovechamiento', '♻️ Sustentabilidad'].map((tag, i) => <span key={i} className="bg-[#0F241C] text-[#BFC9C5] text-[10px] md:text-xs font-bold px-2 py-1 rounded border border-[#1F3D2B]" data-id="element-205">
              {tag}
            </span>)}
        </div>

        <div className="bg-[#0B1F17] rounded-lg p-2 inline-block mb-4 w-full max-w-lg border border-[#1F3D2B]" data-id="element-206">
          <p className="text-[#D4A843] font-black text-sm md:text-base" data-id="element-207">
            👉 Todo organizado para que solo tengas que enseñar.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row justify-center gap-2 max-w-md mx-auto" data-id="element-208">
          <CTAButton variant="primary" className="w-full text-sm" data-id="element-209">
            VER OPCIONES DE COMPRA
          </CTAButton>
        </div>
      </div>
    </section>;
}